export * from "-!../node_modules/extract-text-webpack-plugin/dist/loader.js??ref--10-0!../node_modules/vue-style-loader/index.js!../node_modules/css-loader/index.js??ref--10-2!../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../node_modules/postcss-loader/lib/index.js??ref--10-3!../node_modules/sass-loader/lib/loader.js??ref--10-4!../node_modules/vue-loader/lib/index.js??vue-loader-options!./App.vue?vue&type=style&index=2&id=7dcad0e4&prod&lang=scss&"


//////////////////
// WEBPACK FOOTER
// ./src/App.vue?vue&type=style&index=2&id=7dcad0e4&prod&lang=scss&
// module id = MYIG
// module chunks = 1